const paths = {
  BASE_LOGGED_IN: '/secure',
  LOGIN: '/',
  FORGOT_PASSWORD: '/forgot-password',
  FORGOT_INFO: '/forgot-info',
  PASSWORD_RESET: '/PwdRst',
  LOGOUT: '/secure/logout',
  DASHBOARD: '/secure/dashboard',
  SURRENDERS: '/secure/surrenders',
  SURRENDERS_OPERATIONS: '/secure/operations',
  SURRENDERS_CONTABILITIES: '/secure/contabilities',
  SURRENDERS_COST_CENTERS: '/secure/cost-centers',
  SURRENDERS_COST_CENTERS_MAINTENANCE: '/secure/cost-centers-maintenance',
  SURRENDERS_CASH: '/secure/cash',
  SURRENDERS_CASH_READING: '/secure/cash-reading',
  SURRENDERS_CREATE: '/secure/operations/create',
  SURRENDERS_CREATE_ITEM: '/secure/operations/create/item',
  SURRENDERS_UPDATE_ITEMS: '/secure/operations/item/:idRendicion/update',
  SURRENDERS_CONFIRM: '/secure/confirm-success',
  SURRENDERS_ITEM_DETAIL: '/secure/cash/item/:idRendicion/detail',
  SURRENDERS_ITEM_DETAIL_READING: '/secure/cashReading/item/:idRendicion/detail',
  SURRENDERS_ITEM_DETAIL_CECO: '/secure/cost-centers/item/:idRendicion/detail-ceco',
  SURRENDERS_ITEMS_CONTABILIDAD: '/secure/contabilities/item/:idRendicion/detail-contabilidad',
  MASTER_DATA: '/secure/masters',
  COLLABORATORS: '/secure/collaborators',
  COLLABORATORS_RESPONSABLE: '/secure/collaborators-partial',
  CONFIGURATIONS: '/secure/settings',
  SURRENDERS_CASH_QUERY: '/secure/cash/query',
  CHANGE_PASSWORD: '/secure/changePassword',
  PROFILE: '/secure/profile',
  TREASURY_CASH_OPEN: '/secure/treasury/cash-open',
  ADVANCE_REQUESTS: '/secure/cash/advance-requests',
  REFOUNDS_REQUESTS: '/secure/cash/refounds-requests',
  CASH_BALANCE: '/secure/cash/cash-balance',
  CASH_BALANCE_READING: '/secure/cash/cash-balance-reading',
  CASHIER_PAYMENT: '/secure/treasury/cashier-payment',
  ADVANCE_OPERATION: '/secure/advance/operations',
  ADVANCE_REFUND: '/secure/refund/operations',

  VEHICLE: '/secure/vehicle-maintenance',
  CREWS: '/secure/crews',
  CHECKLISTS: '/secure/check_list',
  FOLLOW_UP: '/secure/follow_up',
  MANTENANCE_VEHICLE_TYPE_DOCUMENT: '/secure/vehicle_type_document',
  SHIFT_MANTENANCE: '/secure/division_shifts',
  FOLLOW_UP_TASKS: '/secure/task_tracking',
  TASKS: '/secure/task',
}

export default paths

